/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
const e={disableDelayMs:2e3};export{e as meshAutoFastUpdateConstants};
